import React from 'react';
import PropTypes from 'prop-types';

export default class ListingSelect extends React.PureComponent {
    constructor(...args) {
        super(...args);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.onChange({ [this.props.config.name]: e.target.value });
    }

    render() {
        const config = this.props.config;
        return (
            <div>
                <div className="select-label">{config.label}</div>
                <div className="select select--white select--small">
                    <select value={this.props.value}
                        onChange={this.onChange}
                        className="select__control">
                        {config.options.map((option, index) => (
                            <option key={index} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                    <svg className="select__arrow">
                        <use xlinkHref="#icon-arrow-bottom"></use>
                    </svg>
                </div>
            </div>
        );
    }
}

ListingSelect.propTypes = {
    config: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
